import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DrawdownIncomeAmendmentInstruction } from '../../Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction';

declare var IS_RUNNING_IN_APP_POOL;

export class ImmediateTaxFreeCashIncomeRequestClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(immediateTaxFreeCashIncomeRequestId: number, subaccountHierarchyId: string): Promise<DrawdownIncomeAmendmentInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/ImmediateTaxFreeCashIncomeRequest/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { immediateTaxFreeCashIncomeRequestId: immediateTaxFreeCashIncomeRequestId, subaccountHierarchyId: subaccountHierarchyId }

    return AjaxWrapper.post<DrawdownIncomeAmendmentInstruction, any>(url, data);
  }
}

